import { render, staticRenderFns } from "./EmployeeCounterTable.vue?vue&type=template&id=55b00855"
import script from "./EmployeeCounterTable.vue?vue&type=script&lang=js"
export * from "./EmployeeCounterTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports